import { Menu, Tooltip, ActionIcon, Group, Text, useMantineTheme, UnstyledButton } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { CaptureColorSelectionValues } from 'utils/constants';

const ColourTag = ({color, onColourChange, layout="dropdown", selectedValues=[]}) => {
    
    const theme = useMantineTheme();
    const SWATCH_SIZE = 14;
    const defaultColor = theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.gray[8]
    
    const [colourSwatch,setColourSwatch] = useState(() => {
        // Initialize with the correct color value
        const swatch = CaptureColorSelectionValues.find(val => val.value === color)
        return swatch ? theme.colors[swatch.color][8] : defaultColor
    })

    
    useEffect(() => {
        // find the colour swatch for the colour
        var swatch = CaptureColorSelectionValues.find(val => val.value === color)
        if(swatch){
            const themeColor = swatch.color === 'gray' && theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors[swatch.color][8]
            console.log('Color:', color, 'Swatch:', swatch, 'Theme color:', themeColor)
            // Ensure we have a valid hex color
            if (themeColor && typeof themeColor === 'string' && themeColor.startsWith('#')) {
                setColourSwatch(themeColor)
            } else {
                setColourSwatch(defaultColor)
            }
        } else {
            // Fallback to black if no swatch found
            setColourSwatch(defaultColor)
        }
    }, [color, theme])
    return (
        
        <>
        {layout === 'dropdown'?
      <Menu shadow='md' width={200}>
      <Menu.Target>
          <Tooltip position='bottom' label='Colour Tag'>
          
              <ActionIcon size='xs'>
              <div style={{display:'flex', alignItems:'center', justifyContent:'center', width: SWATCH_SIZE, height:SWATCH_SIZE, backgroundColor:colourSwatch, borderRadius:theme.radius.sm }}></div>    
              </ActionIcon>
          
          </Tooltip>
      </Menu.Target>

      <Menu.Dropdown>
          {/* <Menu.Label>Color</Menu.Label> */}
          {CaptureColorSelectionValues.map((val, idx) => {
            
              return (
                <Menu.Item sx={(theme) => ({fontSize:'12px',paddingTop:'4px !important',paddingBottom:'4px !important'})} size='sm' py='xs' my={0} key={idx} onClick={(e) => onColourChange(val.value)}>
                      {val.color && theme.colors[val.color]?
                      <Group spacing={'xs'}>
                          <div style={{display:'flex', alignItems:'center', justifyContent:'center', width: SWATCH_SIZE, height:SWATCH_SIZE, backgroundColor:val.color === 'gray' && theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors[val.color][8], borderRadius:theme.radius.sm }}>{val.value === color ? <IconCheck size={14} color={theme.white} /> : null}</div>
                          <Text size='sm'>{val.label}</Text>
                      </Group>:
                      <Text size='sm'  onClick={(e) => onColourChange('')}>{color}</Text>
                      }
                  </Menu.Item>
              );
          })}
          
      </Menu.Dropdown>
  </Menu>
        :
        <Group spacing={5}>
       {CaptureColorSelectionValues.map((val, idx) => {
            
              return (
                
                <Tooltip key={idx} position='bottom' label={val.label}>
                    <UnstyledButton size='xs' style={{cursor:'pointer', width:SWATCH_SIZE, height:SWATCH_SIZE}} onClick={(e) => onColourChange(val.value)}>
                        <div style={{display:'flex', alignItems:'center', justifyContent:'center', width: SWATCH_SIZE, height:SWATCH_SIZE, backgroundColor:val.color === 'gray' && theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors[val.color][8], borderRadius:theme.radius.sm }}>{selectedValues?.indexOf(val.value) !== -1 ? <IconCheck size={14} color={theme.white} /> : null}</div>
                    </UnstyledButton>
                </Tooltip>
              );
          })}
        </Group>
        }
        </>

    )
  }

  export default ColourTag;